(function ($) {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
}(jQuery));

$(function () {
    const $body = $('body');

    $body.on('click', '.mobile-menu-button', (event) => {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        event.preventDefault();
        $('.header-wrap').toggleClass('-translate-x-[200%]').toggleClass('translate-x-0');
        $('#openbtn').toggleClass('hidden');
        $('#closebtn').toggleClass('hidden');

    });

    $body.on('click', '.mobile-navigation li', () => {
        $('.header-wrap').removeClass('translate-x-0').addClass('-translate-x-[200%]');

    });

    $('.questions, .questions__a').hide();

    $("h2").on("click", function () {
        $(this).parent().children(".questions").toggleClass("open");
        $(this).children(".fa-chevron-right").toggleClass("transition ease-in-out rotate-90");
        $(this).children().toggleClass("open");
        $(this).parent().children(".questions").slideToggle();
    });

    $(".questions__q").on("click", function () {
        $(this).next(".questions__a").slideToggle();
    });
});

(function ($) {
    const $body = $('body');

    const $dueDateInput = $('#due-date');
    const $dateOfBirthInput = $('#date-of-birth');
    const $childDateOfBirthInput = $('#child-date-of-birth');

    const dateFormat = 'dd-mm-yy';
    const changeMonth = true;
    const changeYear = true;

    if ($dueDateInput.length) {
        $dueDateInput.datepicker({
            dateFormat,
            changeMonth,
            changeYear,
            showAnim: '',

            beforeShow: () => {
                $dueDateInput
                    .datepicker('option', 'minDate', '+1D')
                    .datepicker('option', 'maxDate', '+8M +14D');

                $body.addClass('prevent-scroll');
            },

            onClose: () => {
                $body.removeClass('prevent-scroll');
            }
        });
    }

    if ($childDateOfBirthInput.length) {
        $childDateOfBirthInput.datepicker({
            dateFormat,
            changeMonth,
            changeYear,
            showAnim: '',

            beforeShow: () => {
                $childDateOfBirthInput
                    .datepicker('option', 'minDate', '-12Y')
                    .datepicker('option', 'maxDate', '+0D');

                $body.addClass('prevent-scroll');
            },

            onClose: () => {
                $body.removeClass('prevent-scroll');
            }
        });
    }

    if ($dateOfBirthInput.length) {
        $dateOfBirthInput.datepicker({
            dateFormat,
            changeMonth,
            changeYear,
            showAnim: '',

            beforeShow: () => {
                $dateOfBirthInput
                    .datepicker('option', 'yearRange', '-55:-16')
                    .datepicker('option', 'defaultDate', '-29Y');

                $body.addClass('prevent-scroll');
            },

            onClose: () => {
                $body.removeClass('prevent-scroll');
            }
        });
    }

    // $(window).resize(function () {
    //     $dueDateInput.datepicker('hide');
    //     $dateOfBirthInput.datepicker('hide');
    //     $childDateOfBirthInput.datepicker('hide');
    // });

    $.datepicker.regional['nl'] = {
        clearText: 'Effacer',
        clearStatus: '',
        closeText: 'sluiten',
        closeStatus: 'Onveranderd sluiten ',
        prevText: '<vorige',
        prevStatus: 'Zie de vorige maand',
        nextText: 'volgende>',
        nextStatus: 'Zie de volgende maand',
        currentText: 'Huidige',
        currentStatus: 'Bekijk de huidige maand',
        monthNames: [
            'januari',
            'februari',
            'maart',
            'april',
            'mei',
            'juni',
            'juli',
            'augustus',
            'september',
            'oktober',
            'november',
            'december'
        ],
        monthNamesShort: [
            'Januari',
            'Februari',
            'Maart',
            'April',
            'Mei',
            'Juni',
            'Juli',
            'Augustus',
            'September',
            'Oktober',
            'November',
            'December'
        ],
        monthStatus: 'Bekijk een andere maand',
        yearStatus: 'Bekijk nog een jaar',
        weekHeader: 'Sm',
        weekStatus: '',
        dayNames: [
            'zondag',
            'maandag',
            'dinsdag',
            'woensdag',
            'donderdag',
            'vrijdag',
            'zaterdag'
        ],
        dayNamesShort: [
            'zo',
            'ma',
            'di',
            'wo',
            'do',
            'vr',
            'za'
        ],
        dayNamesMin: [
            'zo',
            'ma',
            'di',
            'wo',
            'do',
            'vr',
            'za'
        ],
        dayStatus: 'Gebruik DD als de eerste dag van de week',
        dateStatus: 'Kies DD, MM d',
        dateFormat: 'dd/mm/yy',
        firstDay: 1,
        initStatus: 'Kies een datum',
        isRTL: false
    };

    $.datepicker.setDefaults($.datepicker.regional[window.App.locale]);
}(jQuery));

(function ($) {

    const $phoneField = $('form #phone');

    if ($phoneField.length) {
        const phoneRegex = new RegExp('^((\\+|00(\\s|\\s?\\-\\s?)?)31(\\s|\\s?\\-\\s?)?(\\(0\\)[\\-\\s]?)?|0)[1-9]((\\s|\\s?\\-\\s?)?[0-9])((\\s|\\s?-\\s?)?[0-9])((\\s|\\s?-\\s?)?[0-9])\\s?[0-9]\\s?[0-9]\\s?[0-9]\\s?[0-9]\\s?[0-9]$');

        $phoneField.on('keyup', () => {
            let val = $phoneField.val();

            $phoneField.val(val.replace(/[^\d]/g, ''));

            $phoneField.parent().toggleClass('incorrect', !val.match(phoneRegex));
        });
    }
}(jQuery));

(function ($) {

    function show_tab(element) {
        element.addClass('active');
        element.parent().siblings().children().removeClass('active');

        const tab = element.attr('href');
        $('.tab-pane').not(tab).hide();

        $(tab).show();
    }

    const target = window.location.hash;
    if (target && $(target).length) {
        const tab = $('[href="' + target + '"]');

        show_tab(tab);
    }

    $("[data-toggle=tab]").on('click', function (event) {
        show_tab($(this));
    });
}(jQuery));
